export default __webpack_public_path__ + "static/media/8.0a43b891.jpg";